import {
  MissionIdentifier,
  MissionSuccessNotification_CongratulationStage_CTA,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/mission.types';
import {Button} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC, Fragment, startTransition} from 'react';
import {useClaimMissionReward} from '../../../backend-services/Coins/utils/useClaimMissionReward';
import {useInvalidateWallet} from '../../../backend-services/Wallet/utils/useInvalidateGetWallet';
import {useOpenCoinsClaimPopup} from '../CoinsWallet/ClaimedCoins/useOpenCoinsClaimPopup';

export const ClaimNowButton: FC<
  MissionSuccessNotification_CongratulationStage_CTA & {
    missionIdentifier: MissionIdentifier;
    className?: string;
    Wrapper?: React.FC<{children: React.ReactNode}>;
    onClick?: VoidFunction;
    onBeforeClick?: VoidFunction;
  }
> = ({
  label,
  missionIdentifier,
  className,
  Wrapper: BaseWrapper,
  onClick,
  onBeforeClick,
}) => {
  const Wrapper = BaseWrapper ?? Fragment;
  const {open} = useOpenCoinsClaimPopup();
  const {claimMissionReward, isPending} = useClaimMissionReward();
  const invalidateWallet = useInvalidateWallet();

  const handleOnClick = async (e: React.SyntheticEvent) => {
    e.stopPropagation();
    onBeforeClick?.();
    const claimResponse = await claimMissionReward(missionIdentifier);

    onClick?.();

    // we want to make sure the mission popup is closed before opening the claim popup, to avoid UI conflicts on mobile
    setTimeout(() => {
      open({claimResponse, missionIdentifier});
    });
    startTransition(() => {
      invalidateWallet();
    });
  };

  return (
    <Wrapper>
      <StyledButton
        onClick={handleOnClick}
        className={className}
        isLoading={isPending}
      >
        {label}
      </StyledButton>
    </Wrapper>
  );
};

const StyledButton = styled(Button)`
  && {
    min-height: 32px;
  }
`;
